module.exports = __webpack_public_path__ + "static/media/Location-Hero.0f666286.jpg";